<div class="form-group" *ngIf="auth.isUserLoggedIn()">
  <app-loading-panel [showLoading]="customerProfileStatus == 'UPDATING'" [variant]="'inline'"/>
  <div class="font-size-secondary" *ngIf="hasChanges() && customerProfileStatus != 'UPDATING'">
    <label class="custom-checkbox-label">
      <input class="checkbox" type="checkbox" appPreventDoubleClick [throttleTime]="3000"
             (throttledClick)="submitChanges()"/>
      <span> {{ 'public.checkout.saveCustomerDetailsForFuture' | translate }}</span>
    </label>
  </div>
  <div class="input-group valid-feedback font-size-secondary" *ngIf="updateFired && customerProfileStatus == 'SUCCESS'">
    <span> {{ 'public.checkout.customerDetailsUpdateSuccess' | translate }}</span>
  </div>
  <div class="input-group invalid-feedback font-size-secondary"
       *ngIf="updateFired && customerProfileStatus == 'FAILED'">
    <span> {{ 'public.checkout.errors.customerDetailsUpdateFailed' | translate }}</span>
  </div>
</div>
